import React, { useState, useRef } from 'react'
import styles from './styles.module.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TimeLine = ({ data, layout }) => {
  const sliderRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const timelineData = [
    {
      image: 'images/Frame_1.webp',
      date: 'Gennaio 1996',
      textEnglish: 'Bruno Farmaceutici was founded by Dr. Antonio Bruno, and his son Vincenzo.',
    },
    {
      image: 'images/Frame_1.webp',
      date: 'Luglio 1996',
      textEnglish: 'Bruno Farmaceutici has acquired a portfolio of drugs from Hoechst Marion Roussel (Germany) and begins its commercial operations in Italy.',
    },
    {
      
      image: 'images/Frame_4.webp',
      date: '1997-2001',
      textEnglish: 'Bruno Farmaceutici expands its portfolio by acquiring more drugs from multinational pharmaceutical companies.',
    },
    {
      image: 'images/Frame_3.webp',
      date: '2001',
      textEnglish: "Dr. Bruno's daughter, Mariolina joins the company.",
    },
    {
      image: 'images/Frame_5.webp',
      date: '2001 – 2011',
      textEnglish: 'Bruno Farmaceutici has developed in Italy as a company specializing in osteoporosis, pain management and cardiovascular.',
    },
    {
      image: 'images/Frame_6.webp',
      date: '2012',
      textEnglish: 'Bruno Farmaceutici acquires a portfolio of anti-diabetic products from Merck.',
    },
    {
      image: 'images/Frame_7.webp',
      date: '2012',
      textEnglish: 'Bruno Farmaceutici launches the first liquid beverage Alendronate in Italy.',
    },
    {
      image: 'images/Frame_8.webp',
      date: '2015',
      textEnglish: 'Bruno Farmaceutici launches the first controlled-release Flecainide in Italy.',
    },
    {
      image: 'images/Frame_9.webp',
      date: '2017',
      textEnglish: 'Bruno Farmaceutici begins its commercial operations in the United States of America, founding Bruno MD.',
    },
    {
      image: 'images/Frame_10.webp',
      date: '2019',
      textEnglish: 'Bruno Farmaceutici develops the first soft-gel capsule containing Calcidiol (Vitamin D)',
    },
    {
      image: 'images/Frame_11.webp',
      date: '2021',
      textEnglish: 'Bruno Farmaceutici achieves an international global commercial presence.',
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    autoplay: true,
    slidesToScroll: 1,
    // vertical: true, 
    // verticalSwiping: true,
    initialSlide: 0,
    pauseOnHover: true,
    beforeChange: (current, next) => setActiveSlide(next),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          pauseOnHover: false,
          speed: 1500,


        },
      },
    ],
  };

  // Custom Next Button
  const nextSlide = () => {
    sliderRef.current.slickNext();
  };

  // Custom Prev Button
  const prevSlide = () => {
    sliderRef.current.slickPrev();
  };

  // Jump to a specific slide (based on pagination number)
  const goToSlide = (index) => {
    sliderRef.current.slickGoTo(index);
  };
  return (
    <div className={styles.sliderContainer}>
      {/* Slider */}
      <Slider ref={sliderRef} {...settings}>
        {timelineData.map((slide, index) => (
          <div
            key={index}
            className={`${styles.SliderImg} ${activeSlide === index ? styles.active : ''}`}
          >
            <img src={slide.image} alt={`Slide ${index + 1}`} />
            <div className={styles.sliderText}>
              <h2>{slide.date}</h2>
              <p>{slide.textEnglish}</p>
            </div>
          </div>
        ))}

      </Slider>

      <div className={styles.paginationContainer}>
        <div className={styles.paginationDiv}>
          <svg className={styles.prevButton} onClick={prevSlide} width="47" height="46" viewBox="0 0 47 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.1797 28.4039L23.5406 17.043L34.9015 28.4039" stroke="#56008C" stroke-width="2" />
          </svg>

          <div className={styles.pagination}>
            {timelineData.map((slide, index) => (
              <button
                key={index}
                className={activeSlide === index ? styles.activeButton : ''}
                onClick={() => goToSlide(index)}
              >
                <span className={styles.dot}></span> {slide.date}
              </button>
            ))}
          </div>
          <svg className={styles.nextButton} onClick={nextSlide} width="47" height="46" viewBox="0 0 47 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M34.9004 17.2758L23.5395 28.6367L12.1786 17.2758" stroke="#56008C" stroke-width="2" />
          </svg>

        </div>
      </div>
    </div>
  )
}

export default TimeLine